import React, { useState, useEffect, useCallback, useRef } from "react";
import { useAuthContext } from "contexts/Auth";
import { Link } from "react-router-dom";
import axios from "axios";

import avatar from "assets/images/avatar.png"
import { Badge, Button, Image } from "antd";
import messageTone from "assets/audios/mixkit-software-interface-start-2574.wav";

export default function Navbar() {

  const { user, isSuperAdmin, handleLogout, getApiConfig } = useAuthContext()
  const [messages, setMessages] = useState(0);
  const messageAudioPlayer = useRef();

  const readDocuments = useCallback(async () => {
    axios.get(`${window.api}/messages/all-unread`, getApiConfig())
      .then((res) => {
        const { data, status } = res
        if (status === 200) {
          setMessages(data.messages)
          // messageAudioPlayer.current.play();
        }
      })
      .catch(error => {
        console.error(error)
        window.toastify(error.response?.data?.message || "Something went wrong while getting the messages", "error")
      })
  }, [getApiConfig])
  useEffect(() => { if (isSuperAdmin) readDocuments() }, [isSuperAdmin, readDocuments])

  return (
    <>
      <header className="position-sticky top-0" style={{ zIndex: 100 }}>
        <nav className="navbar navbar-expand-lg bg-primary navbar-dark">
          <div className="container-fluid">
            <Image src={window.logoLight} preview={false} height={60} className='company-nav-logo' />
            <div className="d-flex">
              <div className="collapse navbar-collapse">
                <ul className="navbar-nav me-auto">
                  <li className="nav-item dropdown me-3">
                    <button className="nav-link dropdown-toggle border-0 bg-transparent d-flex align-items-center p-0" data-bs-toggle="dropdown">
                      <span className="text-white d-inline-block me-2 text-end">
                        <small className="fw-bold">{user.firstName} ({user.roles[0]})</small>
                      </span>
                      <img src={user.photoURL || avatar} alt="Profile Pic" className="rounded-circle" />
                    </button>
                    <ul className="dropdown-menu pb-0">
                      <li><Link to="/dashboard/settings/profile" className="dropdown-item"><i className="fa-regular fa-user"></i>My Profile</Link></li>
                      <li><Link to="/dashboard/settings/account" className="dropdown-item"><i className="fa-solid fa-gears"></i>Account Settings</Link></li>
                      {/* <li><button className="btn btn-danger text-white btn-sm w-100" onClick={handleLogout}>Logout</button></li> */}
                      <li><Button type="primary" danger block style={{ borderTopLeftRadius: 0, borderTopRightRadius: 0 }} onClick={handleLogout}>Logout</Button></li>
                    </ul>
                  </li>
                  {isSuperAdmin && (
                    <li className="nav-item">
                      <Link to="/dashboard/messages/all" className="nav-link">
                        <Badge count={messages}>
                          <i className="fa-regular fa-envelope position-relative"></i>
                        </Badge>
                      </Link>
                    </li>
                  )}
                  {/* <li className="nav-item"><Link to="/dashboard/notifications" className="nav-link"><i className="fa-regular fa-bell"></i></Link></li> */}
                </ul>
              </div>
            </div>
          </div>
        </nav>
      </header>
      <audio ref={messageAudioPlayer} src={messageTone}></audio>
    </>
  );
}
